var map = {
	"./1_PCN_Logo_Main_PRIMARY (1).png": 124,
	"./Ambidextr.png": 125,
	"./BACKBASE.png": 126,
	"./Coinsdataflow.jpeg": 127,
	"./Cointelegraph.jpeg": 128,
	"./Kitamo.png": 129,
	"./ManageEngine.png": 130,
	"./NewsAffinity.jpeg": 131,
	"./NewsAffinity.png": 132,
	"./PaymentsAfrika.png": 133,
	"./TEMENOS.png": 134,
	"./TP.png": 135,
	"./africa.jpeg": 136,
	"./baa.png": 137,
	"./bankserv.jpg": 138,
	"./beincrypto.jpeg": 139,
	"./beingcrypto.jpg": 140,
	"./bigdata.jpeg": 141,
	"./blocksocial.png": 142,
	"./caia.jpeg": 143,
	"./cbon.png": 144,
	"./cexio.jpg": 145,
	"./coinmercury.jpeg": 146,
	"./coinsflare.png": 147,
	"./consdata.png": 148,
	"./cryptonewz.jpeg": 149,
	"./csa.png": 150,
	"./ct.jpeg": 151,
	"./daon.jpg": 152,
	"./darktrace.png": 153,
	"./difc.jpg": 154,
	"./edb.jpg": 155,
	"./edb.png": 156,
	"./expo2020.jpg": 157,
	"./expo2020.png": 158,
	"./financialit.jpeg": 159,
	"./find.jpeg": 160,
	"./findbiometrics.jpeg": 161,
	"./fintechfutures.jpeg": 162,
	"./fintechna.jpeg": 163,
	"./fintechna.jpg": 164,
	"./fintechpower.jpeg": 165,
	"./fintechtimes.jpeg": 166,
	"./fireeye.png": 167,
	"./ibm.jpeg": 168,
	"./ie.jpg": 169,
	"./mobile.jpeg": 170,
	"./mobileidworld.jpeg": 171,
	"./onespan.jpg": 172,
	"./oracle.jpg": 173,
	"./oxford.jpeg": 174,
	"./privatebanking.jpeg": 175,
	"./pwc.jpg": 176,
	"./recorded.png": 177,
	"./rubrik.jpg": 178,
	"./scventure.jpg": 179,
	"./silicon.jpeg": 180,
	"./tcs.jpg": 181,
	"./threatLocker.jpg": 182,
	"./tripwire.jpg": 183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;